// Progressive enhancement only: Shopify remains responsible for submission,
// customer records, marketing consent, challenges and the backend response.
class LimitlessNewsletter extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.form = this.querySelector('form');
    this.button = this.form?.querySelector('button[type="submit"]');
    this.status = this.querySelector('[data-newsletter-status]');
    if (!this.form || !this.button) return;
    this.initiallyDisabled = this.button.disabled;
    this.pending = false;

    this.form.addEventListener('submit', (event) => {
      if (event.defaultPrevented) return;
      if (this.pending) {
        event.preventDefault();
        return;
      }
      // Let Shopify's challenge handlers cancel/intercept the native submit.
      // Never lock the form while a CAPTCHA or another handler owns submission.
      queueMicrotask(() => {
        if (event.defaultPrevented || !this.isConnected) return;
        this.pending = true;
        this.form.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        if (this.status) this.status.textContent = this.status.dataset.sendingMessage;
      });
    }, { signal: this.controller.signal });

    window.addEventListener('pageshow', () => this.reset(), { signal: this.controller.signal });
  }

  reset() {
    this.pending = false;
    this.form?.removeAttribute('aria-busy');
    if (this.button) this.button.disabled = this.initiallyDisabled;
    if (this.status) this.status.textContent = '';
  }

  disconnectedCallback() {
    this.reset();
    this.controller?.abort();
  }
}

if (!customElements.get('limitless-newsletter')) {
  customElements.define('limitless-newsletter', LimitlessNewsletter);
}
